<script>
import StudyList from '../../components/studyList.vue';

export default {
    name: "exhibition",
    data() {
        return {
            exhibition_list: [
                {
                    image: require('@/assets/images/home_banner.jpg'),
                    tag: '傅冲个展',
                    name: '时尚生活的色彩',
                    time_text: '2025年3月10日、12月24、12月25不开放',
                },
                {
                    image: require('@/assets/images/home_banner.jpg'),
                    tag: '傅冲个展',
                    name: '时尚生活的色彩',
                    time_text: '2025年3月10日、12月24、12月25不开放',
                },
                {
                    image: require('@/assets/images/home_banner.jpg'),
                    tag: '傅冲个展',
                    name: '时尚生活的色彩',
                    time_text: '2025年3月10日、12月24、12月25不开放',
                },
            ],
            study_list: [
                {
                    image: require('@/assets/images/home_banner.jpg'),
                    tag: '在线',
                    desc: '奢颜在线课程',
                    name: '爱心',
                    start_time: '2025.04.03',
                    end_time: '2025.04.11',
                    price: '199.00',
                },
                {
                    image: require('@/assets/images/home_banner.jpg'),
                    tag: '在线',
                    desc: '奢颜在线课程',
                    name: '爱心',
                    start_time: '2025.04.03',
                    end_time: '2025.04.11',
                    price: '199.00',
                },
                {
                    image: require('@/assets/images/home_banner.jpg'),
                    tag: '在线',
                    desc: '奢颜在线课程',
                    name: '爱心',
                    start_time: '2025.04.03',
                    end_time: '2025.04.11',
                    price: '199.00',
                },
            ]
        };
    },
    computed: {},
    components: {
        StudyList
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="exhibition layout_main">
        <div class="top">
            <p class="desc">无需提前预订。出示会员卡，即可参观您心仪的展览，即使门票已售罄</p>
        </div>
        <!--  -->
        <div class="wrapper">
            <div class="top">
                <p class="title">探索会员福利</p>
                <p class="desc">立即以会员身份享受这些福利</p>
            </div>
            <router-link class="buy" to="buy" append>
                <div class="layout_bg bg" :style="`background-image: url();`"></div>
                <div class="content">
                    <p class="name">无限次免费参观展览<br/>--- 从今天开始</p>
                    <p class="desc">无需提前预订<br/>即使门票已售完，也可以参观展览<br/>免费携带最多四名 16 岁以下儿童</p>
                </div>
            </router-link>
        </div>
        <!--  -->
        <div class="wrapper">
            <div class="top">
                <p class="title">正在上映</p>
            </div>
            <div class="exhibition_list flex flex_wrap">
                <router-link class="item flex flex_column" v-for="(item, index) in exhibition_list" :key="index" :to="`/gallery/latestNews/detail?id=${item.id}`">
                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                    <div class="text flex flex_column">
                        <p class="type">{{ item.tag }}</p>
                        <p class="name">{{ item.name }}</p>
                        <div class="time flex align_start">
                            <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                            <p>{{ item.time_text }}</p>
                        </div>
                        <div class="flex justify_between">
                            <div class="price flex align_center">
                                <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                <p>会员免费</p>
                            </div>
                            <div class="btn layout_flex_center only_pc">更多信息</div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <!--  -->
        <div class="wrapper">
            <div class="top">
                <p class="title">课程与活动</p>
            </div>
            <StudyList :data="study_list" type="type2"/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.exhibition{
    padding: .35rem 0;
}
.wrapper{
    padding-bottom: .5rem;
}
.top{
    margin-bottom: .3rem;
    .title{
        font-size: .26rem;
        text-align: center;
    }
    .desc{
        text-align: center;
        font-size: .18rem;
    }
    @media only screen and (max-width: 750px) {
        .title{
            font-weight: bold;
        }
        .desc{
            font-size: .2rem;
        }
    }
}
.buy{
    height: 4.5rem;
    border: 1px solid #666;
    display: block;
    position: relative;
    @media only screen and (max-width: 750px) {
        height: 4rem;
    }
    .content{
        position: absolute;
        left: .4rem;
        bottom: .4rem;
        @media only screen and (max-width: 750px) {
            left: .3rem;
            bottom: .3rem;
        }
        .name{
            font-size: .3rem;
            margin-bottom: .2rem;
        }
        .desc{
            font-size: .16rem;
            line-height: 2;
            @media only screen and (max-width: 750px) {
                font-size: .18rem;
            }
        }
    }
}
.exhibition_list{
    gap: .54rem;
    .item{
        // width: 3.36rem;
        width: 3.64rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .cover{
            height: 0;
            padding-bottom: 80.36%;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                padding-bottom: 65.21%;
            }
        }
        .text{
            flex: 1;
            @media only screen and (max-width: 750px) {
                align-items: center;
            }
        }
        .type{
            font-size: .2rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .name{
            font-size: .24rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
            }
        }
        .time{
            font-size: .18rem;
            margin-bottom: .2rem;
            flex: 1;
            @media only screen and (max-width: 750px) {
                font-size: .22rem;
                // margin-bottom: 0;
            }
            .icon{
                margin-top: .02rem;
            }
        }
        .price{
            font-size: .18rem;
            @media only screen and (max-width: 750px) {
                font-size: .22rem;
            }
        }
        .icon{
            margin-right: .1rem;
            &.calendar{
                width: .21rem;
            }
            &.price{
                width: .24rem;
            }
            @media only screen and (max-width: 750px) {
                &.calendar{
                    width: .29rem;
                }
                &.price{
                    width: .32rem;
                }
            }
        }
        .btn{
            font-size: .18rem;
            color: #666;
            border: 1px solid #666;
            border-radius: .1rem;
            height: .35rem;
            padding: 0 .15rem;
            cursor: pointer;
        }
    }
}
</style>